module.exports = __webpack_public_path__ + "img/adv_dis.40a9b3f8.png";